module.exports = __webpack_public_path__ + "img/py.88a13fe7.png";